import React from "react";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import DetailsCard from "../General/DetailsCard";

const CustomSplitColumnCard: React.FC<{
  title: string;
  enableContentHiding?: boolean;
  content: ({ left: React.ReactNode; right?: React.ReactNode } | null)[];
}> = ({ title, enableContentHiding=true, content }) => {
  return (
    <React.Fragment>
      <Container maxWidth="lg" sx={{ p: 0 }}>
        <DetailsCard cardTitle={title} enableContentHiding={enableContentHiding}>
          <Stack spacing={2} pb={1}>
            {content
              .filter((c) => c != null)
              .map((row, index) => (
                <Grid container key={index}>
                  <Grid item xs={12} md={row!.right ? 6 : 12}>
                    {row!.left}
                  </Grid>
                  {row!.right && (<Grid item xs={12} md={6}>
                    {row!.right}
                  </Grid>)}
                  {index !== content.filter((c) => c != null).length - 1 && (
                    <Grid item xs={12} sx={{ py: 1 }}>
                      <Divider variant="middle" />
                    </Grid>
                  )}
                </Grid>
              ))}
          </Stack>
        </DetailsCard>
      </Container>
    </React.Fragment>
  );
};

export default CustomSplitColumnCard;
